/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const CANCEL_RECURRING_SUBSCRIPTION = "CANCEL_RECURRING_SUBSCRIPTION";
export const CANCEL_RECURRING_SUCCESS = "CANCEL_RECURRING_SUCCESS";
export const FETCH_RECURRING_ORDER = "FETCH_RECURRING_ORDER";
export const FETCH_RECURRING_ORDER_SUCCESS = "FETCH_RECURRING_ORDER_SUCCESS";
export const CANCEL_RECURRING_ERROR = "CANCEL_RECURRING_ERROR";
export const FETCH_RECURRING_ORDER_ERROR = "FETCH_RECURRING_ORDER_ERROR";
export const NOTIFY_CANCEL_RECURRING = "NOTIFY_CANCEL_RECURRING";
